module.exports = __webpack_public_path__ + "img/example-3.3578999f.png";